import { practiceAreas } from '@/data/practiceAreas';
import PracticeAreaTemplate from '@/components/PracticeAreaTemplate';

export default function MedicaidPlanningPage() {
  return <PracticeAreaTemplate practiceArea={practiceAreas['medicaid-planning']} />;
}
